interface RecipeSectionProps {
  title: string;
  children: React.ReactNode;
}

const RecipeSection = ({ title, children }: RecipeSectionProps) => {
  return (
    <>
      <h2 className="recipe-single__title">{title}</h2>

      {children}
    </>
  );
};

export default RecipeSection;
